import { Reveal } from "./Reveal";
import { ArrowUpRight } from "lucide-react";
import { CONTACT } from "../lib/site";

export default function InstagramSection() {
    return (
        <section className="bg-cream py-20 sm:py-28 lg:py-32">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <Reveal>
                    <p className="font-display italic text-lg text-ink/60">
                        "Personalizados para momentos que merecem ser
                        lembrados."
                    </p>
                </Reveal>
                <Reveal delay={0.1}>
                    <p className="font-accent text-[11px] sm:text-xs uppercase tracking-[0.35em] text-gold-deep mt-10">
                        Instagram
                    </p>
                    <h2 className="font-display font-medium text-3xl sm:text-4xl lg:text-5xl text-ink mt-4">
                        Acompanhe a Magnus
                    </h2>
                </Reveal>
                <Reveal delay={0.18}>
                    <p className="font-body text-base text-inksoft leading-relaxed mt-5">
                        Veja nossos trabalhos, novidades e inspirações no
                        Instagram.
                    </p>
                </Reveal>
                <Reveal delay={0.26}>
                    <p className="font-display text-2xl sm:text-3xl text-gold-deep mt-6">
                        {CONTACT.instagram}
                    </p>
                    <a
                        data-testid="instagram-cta"
                        href={CONTACT.instagramUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-8 inline-flex items-center gap-2 border border-ink/25 text-ink font-body text-xs sm:text-sm font-semibold uppercase tracking-[0.16em] px-8 py-4 rounded-full hover:border-gold hover:text-gold-deep transition-all duration-300"
                    >
                        Ver Instagram
                        <ArrowUpRight size={16} />
                    </a>
                </Reveal>
            </div>
        </section>
    );
}
